import * as z from "zod";
import { OverboxLegDtoSchema } from "./overbox-leg-dto";

export const listOverboxLegs = {
  name: "listOverboxLegs" as const,
  input: z.object({}),
  output: z.object({ legs: z.array(OverboxLegDtoSchema) }),
};
